import { IDaasSignup } from '../../services/DaasSignupService';

export const signupFromQuery = (
  applicationId?: string | null,
  redirectUri?: string | null,
  tags?: string | null,
): IDaasSignup => {
  if (applicationId && redirectUri) {
    return {
      email: '',
      applicationId,
      redirectUri,
      tags: tags?.split(','),
    };
  } else {
    let errorMsg = '';

    if (!applicationId) {
      errorMsg = 'application_id_is_required';
    } else if (!redirectUri) {
      errorMsg = 'redirect_uri_is_required';
    } else {
      errorMsg = 'Unable to read all of the required query parameters';
    }
    throw Error(errorMsg);
  }
};
